<template>
  <div class="app-password_apd">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="'input-group-' + i"
        class="input-group"
        @click="removeError(i)">

        <el-input
          type="password"
          v-model="valueLocal[i].password"
          v-bind="widgetOptions"
          clearable
          :class="{ 'required': options.required, 'child-has-error': error[i] }"
          :key="'password-' + i"/>

        <div class="input-group-item" v-if="options.confirm">
          <div
            class="input-subtitle input-subtitle-between"
            :class="{ 'required': options.required }">
            Повторите пароль
          </div>
          <el-input
            type="password"
            v-model="valueLocal[i].confirm"
            v-bind="widgetOptions"
            :class="{ 'child-has-error': error[i] === validateMessages.notConfirmed }"
            clearable
            :key="'password-repeat-' + i"/>
        </div>

        <div v-if="error[i]" class="ait_message ait_message--error">
          {{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import approve from 'approvejs';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: { password: '', confirm: '' },
      errorBase: '',
    };
  },

  created() {
    // Add error messages
    this.validateMessages = Object.assign({
      notConfirmed: 'Пароли должны совпадать!',
      notStrong: `Слабый пароль! Длина пароля должна быть не менее 8 символов. Для усиления
       пароль должен содержать цифры, строчные и заглавные латинские буквы.
       Также рекомендуем добавить такие специальные символы, как @, $, #, % и т.п.`,
    }, this.validateMessages);

    // Default options
    this.options.confirm = this.options && this.options.confirm ? this.options.confirm : false;

    // Process custom local options of this widget type
    if (this.options) {
      if (this.options.minlength) this.widgetOptions.minlength = this.options.minlength;
      if (this.options.maxlength) this.widgetOptions.maxlength = this.options.maxlength;
      if (this.options.placeholder) this.widgetOptions.placeholder = this.options.placeholder;
    }
  },

  methods: {

    getError() {
      // Check if required check needed
      if (this.options.required) {
        this.valueLocal.forEach((el, i) => {
          if (!el.password) this.error[i] = this.validateMessages.required;
        });
      }

      // Check if strength check needed
      if (this.options.strength) {
        const rules = {
          strength: {
            min: 7,
            bonus: 9,
          },
        };
        this.valueLocal.forEach((el, i) => {
          if (this.error[i] || !el.password) return;
          const result = approve.value(el.password, rules);
          if (result.strength.points < 4) {
            this.error[i] = this.validateMessages.notStrong;
          }
        });
      }

      // Check if confirm check needed
      if (this.options.confirm) {
        this.valueLocal.forEach((el, i) => {
          if (this.error[i]) return;
          if (el.password !== el.confirm) {
            this.error[i] = this.validateMessages.notConfirmed;
          }
        });
      }

      this.updateError();
      return this.error;
    },

  },

};
</script>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppPassword.vue